export enum DataType {
  OIL_PRODUCTION = 'oil-production',
  GAS_INJECTION = 'gas-injection',
  WATER_INJECTION = 'water-injection',
  LIQUID_PRODUCTION = 'liquid-production',
  GAS_PRODUCTION = 'gas-production'
}
